"use client";
import React, { useState, useEffect } from 'react';

const ColorGradientPicker = ({ value, onChange }) => {
    const [mode, setMode] = useState('solid');
    const [color1, setColor1] = useState('#000000');
    const [color2, setColor2] = useState('#ffffff');
    const [angle, setAngle] = useState(90);

    useEffect(() => {
        if (!value) {
            setMode('solid');
            setColor1('#000000');
            return;
        }

        if (value.startsWith('linear-gradient')) {
            setMode('gradient');
            const regex = /linear-gradient\((\d+)deg,\s*([^,]+),\s*([^)]+)\)/;
            const match = value.match(regex);
            if (match) {
                setAngle(parseInt(match[1], 10));
                setColor1(match[2].trim());
                setColor2(match[3].trim());
            }
        } else {
            setMode('solid');
            setColor1(value);
        }
    }, [value]);

    const handleSolidChange = (newColor) => {
        setColor1(newColor);
        onChange(newColor);
    };

    const handleGradientChange = (newAngle, c1, c2) => {
        setAngle(newAngle);
        setColor1(c1);
        setColor2(c2);
        onChange(`linear-gradient(${newAngle}deg, ${c1}, ${c2})`);
    };

    return (
        <div className="flex flex-col space-y-3 p-3 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 w-64">
            {/* Tabs */}
            <div className="flex space-x-1 bg-gray-100 dark:bg-gray-900 p-1 rounded-md">
                <button
                    onClick={(e) => {
                        e.preventDefault();
                        setMode('solid');
                        handleSolidChange(color1);
                    }}
                    className={`flex-1 py-1 text-xs font-medium rounded-sm transition-colors ${mode === 'solid' ? 'bg-white dark:bg-gray-700 shadow-sm text-gray-900 dark:text-white' : 'text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'}`}
                >
                    Сплошной
                </button>
                <button
                    onClick={(e) => {
                        e.preventDefault();
                        setMode('gradient');
                        handleGradientChange(angle, color1, color2);
                    }}
                    className={`flex-1 py-1 text-xs font-medium rounded-sm transition-colors ${mode === 'gradient' ? 'bg-white dark:bg-gray-700 shadow-sm text-gray-900 dark:text-white' : 'text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'}`}
                >
                    Градиент
                </button>
            </div>

            {/* Content */}
            {mode === 'solid' ? (
                <div className="flex items-center space-x-2">
                    <input
                        type="color"
                        value={color1}
                        onChange={(e) => handleSolidChange(e.target.value)}
                        className="w-8 h-8 rounded cursor-pointer border-0 p-0 bg-transparent"
                    />
                    <input
                        type="text"
                        value={color1}
                        onChange={(e) => handleSolidChange(e.target.value)}
                        className="flex-1 px-2 py-1 text-sm border rounded dark:bg-gray-900 dark:border-gray-700 dark:text-white uppercase"
                    />
                </div>
            ) : (
                <div className="space-y-3">
                    <div className="flex items-center space-x-2">
                        <span className="text-xs text-gray-500 w-12">Цвет 1</span>
                        <input
                            type="color"
                            value={color1}
                            onChange={(e) => handleGradientChange(angle, e.target.value, color2)}
                            className="w-8 h-8 rounded cursor-pointer border-0 p-0 bg-transparent"
                        />
                        <input
                            type="text"
                            value={color1}
                            onChange={(e) => handleGradientChange(angle, e.target.value, color2)}
                            className="flex-1 px-2 py-1 text-sm border rounded dark:bg-gray-900 dark:border-gray-700 dark:text-white uppercase"
                        />
                    </div>
                    <div className="flex items-center space-x-2">
                        <span className="text-xs text-gray-500 w-12">Цвет 2</span>
                        <input
                            type="color"
                            value={color2}
                            onChange={(e) => handleGradientChange(angle, color1, e.target.value)}
                            className="w-8 h-8 rounded cursor-pointer border-0 p-0 bg-transparent"
                        />
                        <input
                            type="text"
                            value={color2}
                            onChange={(e) => handleGradientChange(angle, color1, e.target.value)}
                            className="flex-1 px-2 py-1 text-sm border rounded dark:bg-gray-900 dark:border-gray-700 dark:text-white uppercase"
                        />
                    </div>
                    <div className="flex items-center space-x-2">
                        <span className="text-xs text-gray-500 w-12">Угол</span>
                        <input
                            type="range"
                            min="0"
                            max="360"
                            value={angle}
                            onChange={(e) => handleGradientChange(parseInt(e.target.value, 10), color1, color2)}
                            className="flex-1"
                        />
                        <span className="text-xs text-gray-500 w-8 text-right">{angle}°</span>
                    </div>
                </div>
            )}

            {/* Preview */}
            <div
                className="w-full h-8 rounded border border-gray-200 dark:border-gray-700"
                style={{ background: mode === 'solid' ? color1 : `linear-gradient(${angle}deg, ${color1}, ${color2})` }}
            ></div>
        </div>
    );
};

export default ColorGradientPicker;